<template>
  <div class="email-notification-field">
    <!-- User already has email -->
    <template v-if="userEmail">
      <div class="email-existing">
        <feather-icon
          icon="MailIcon"
          size="18"
          class="mr-75"
        />
        <span class="email-text">
          {{ $t('DEBTIA_EMAIL_RECEIVE_ON') }} <strong>{{ userEmail }}</strong>
        </span>
        <router-link
          to="/profile"
          class="change-email-link"
        >
          {{ $t('DEBTIA_EMAIL_CHANGE') }}
        </router-link>
      </div>
    </template>

    <!-- User needs to enter email -->
    <template v-else>
      <b-form-group
        :label="$t('DEBTIA_EMAIL_FOR_REPLY')"
        label-for="contact-email"
      >
        <b-form-input
          id="contact-email"
          :value="value"
          type="email"
          :placeholder="$t('DEBTIA_FORM_EMAIL')"
          :state="emailValidation"
          @input="$emit('input', $event)"
        />
        <b-form-invalid-feedback :state="emailValidation">
          {{ $t('DEBTIA_EMAIL_INVALID') }}
        </b-form-invalid-feedback>
        <small class="text-muted mt-50 d-block">
          {{ $t('DEBTIA_EMAIL_SAVED') }}
        </small>
      </b-form-group>
    </template>
  </div>
</template>

<script>
import { BFormGroup, BFormInput, BFormInvalidFeedback } from 'bootstrap-vue'

export default {
  name: 'EmailNotificationField',
  components: {
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    userEmail: {
      type: String,
      default: null,
    },
  },
  computed: {
    emailValidation() {
      if (!this.value) return null
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return re.test(this.value)
    },
  },
}
</script>

<style lang="scss" scoped>
.email-notification-field {
  .email-existing {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.25rem;
    padding: 1rem;
    background: rgba(8, 140, 118, 0.08);
    border: 1px solid rgba(8, 140, 118, 0.2);
    border-radius: 0.5rem;
    color: #5e5873;

    svg {
      color: #088c76;
      flex-shrink: 0;
    }

    .email-text {
      font-size: 0.95rem;
    }

    .change-email-link {
      color: #088c76;
      font-size: 0.9rem;
      text-decoration: none;
      margin-left: 0.25rem;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
